/* Neanour: discount code in the cart drawer, auto-apply the popup code, keep the popup away once someone has added to cart. */
(() => {
  const CODE_KEY = 'nea_discount_code';
  const ATC_KEY = 'nea_added_to_cart';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const store = {
    get: (s, k) => { try { return s.getItem(k); } catch (e) { return null; } },
    set: (s, k, v) => { try { s.setItem(k, v); } catch (e) {} },
    del: (s, k) => { try { s.removeItem(k); } catch (e) {} }
  };

  const refreshDrawer = () => {
    const drawer = document.querySelector('m-cart-drawer');
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
  };

  // Ajax Cart API: `discount` replaces the cart's codes; '' clears them.
  const setDiscount = (code) =>
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then((r) => r.json());

  const apply = (code, btn) => {
    code = (code || '').trim();
    if (!code) return Promise.resolve();
    if (btn) btn.setAttribute('aria-busy', 'true');
    return setDiscount(code)
      .then((cart) => {
        const hit = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
        if (hit && hit.applicable) store.set(localStorage, CODE_KEY, code);
        refreshDrawer();
        return cart;
      })
      .catch(() => {})
      .finally(() => btn && btn.removeAttribute('aria-busy'));
  };

  // Drawer: apply / remove
  document.addEventListener('click', (e) => {
    const applyBtn = e.target.closest('[data-nea-discount-apply]');
    if (applyBtn) {
      const input = applyBtn.parentElement.querySelector('[data-nea-discount-input]');
      apply(input && input.value, applyBtn);
      return;
    }
    if (e.target.closest('[data-nea-discount-remove]')) {
      store.del(localStorage, CODE_KEY);
      setDiscount('').then(refreshDrawer).catch(() => {});
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || !e.target.matches('[data-nea-discount-input]')) return;
    e.preventDefault(); // the drawer sits inside the checkout form
    apply(e.target.value, e.target.parentElement.querySelector('[data-nea-discount-apply]'));
  });

  // FoxKit popup: once the thank-you screen shows the code, put it on the cart.
  document.addEventListener('submit', (e) => {
    if (!e.target.closest || !e.target.closest('.foxkit-popup')) return;
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      const span = document.querySelector('.foxkit-popup--success .foxkit-popup__coupon-code span');
      const code = span && span.textContent.trim();
      if (code) {
        clearInterval(timer);
        apply(code).then(() => {
          const box = span.closest('.foxkit-popup__coupon-code');
          if (box && !document.querySelector('.nea-popup-applied')) {
            box.insertAdjacentHTML('afterend', '<p class="nea-popup-applied">Applied to your cart &#10003; You&rsquo;ll see the discount at checkout.</p>');
          }
        });
      } else if (tries > 40) clearInterval(timer);
    }, 500);
  }, true);

  // Re-apply a remembered code if the cart lost it (e.g. it was empty when they signed up).
  const ensureRemembered = () => {
    const code = store.get(localStorage, CODE_KEY);
    if (!code) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        if (!cart.item_count) return;
        const has = (cart.discount_codes || []).some((d) => d.code.toLowerCase() === code.toLowerCase());
        if (!has) apply(code);
      })
      .catch(() => {});
  };

  // After add to cart: close the email popup and keep it closed for this visit.
  const quietPopup = () => {
    document.documentElement.classList.add('nea-atc');
    const modal = document.querySelector('.foxkit-modal--popup.is-open');
    const close = modal && modal.querySelector('[class*="close"]');
    if (close) close.click();
  };
  if (store.get(sessionStorage, ATC_KEY)) document.documentElement.classList.add('nea-atc');

  const onOpen = () => {
    store.set(sessionStorage, ATC_KEY, '1');
    quietPopup();
    ensureRemembered();
  };
  const subscribe = () => {
    if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, onOpen);
      return true;
    }
    return false;
  };
  if (!subscribe()) document.addEventListener('DOMContentLoaded', subscribe);

  const style = document.createElement('style');
  style.textContent =
    'html.nea-atc .foxkit-modal--popup{display:none!important}' +
    '.nea-popup-applied{margin:10px 0 0;font-size:13px;color:#3B3833}';
  document.head.appendChild(style);
})();
